// 发件人认证未通过徽标 —— 收件箱列表 / 搜索结果共用，与详情页「发件人存疑」同一套琥珀色语义。
// CSS-only Tooltip（native title 2 秒延迟不算 hint，CLAUDE.md §四）；
// 浮层放在徽标右侧垂直居中：列表外层是 overflow-x-auto，向下弹会被最后几行裁掉。

import { ShieldAlert } from 'lucide-react';

import type { AuthCheck } from '@aliashub/shared/dto';

const CHECK_LABEL: Record<AuthCheck, string> = { spf: 'SPF', dkim: 'DKIM', dmarc: 'DMARC' };

/** side：浮层朝向。徽标可能贴近右边缘（如搜索结果标题后）时用 'left'。 */
export function AuthSuspiciousBadge({
  failed,
  side = 'right',
}: {
  failed: AuthCheck[];
  side?: 'left' | 'right';
}) {
  if (failed.length === 0) return null;
  const names = failed.map((c) => CHECK_LABEL[c]).join('、');
  return (
    <span
      tabIndex={0}
      aria-label={`发件人认证未通过：${names}`}
      className="group relative inline-flex shrink-0 items-center gap-0.5 rounded bg-amber-100 px-1 py-0.5 text-[10px] font-medium leading-none text-amber-800 outline-none focus-visible:ring-2 focus-visible:ring-amber-400 dark:bg-amber-500/15 dark:text-amber-200"
    >
      <ShieldAlert className="h-3 w-3" aria-hidden="true" />
      <span className="whitespace-nowrap">可疑</span>
      <span
        role="tooltip"
        className={
          (side === 'right' ? 'left-full ml-1.5' : 'right-full mr-1.5') +
          ' pointer-events-none absolute top-1/2 z-20 w-56 -translate-y-1/2 rounded-md bg-slate-900 px-2 py-1.5 text-xs font-normal leading-snug text-white opacity-0 shadow-lg transition-opacity group-hover:opacity-100 group-focus:opacity-100 dark:bg-slate-100 dark:text-slate-900'
        }
      >
        <span className="block font-medium">{names} 未通过</span>
        <span className="block text-slate-300 dark:text-slate-600">
          发件人可能被冒充；转发或邮件列表也会导致误报，详情页可看完整认证结果。
        </span>
      </span>
    </span>
  );
}
